import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { TripsGrid } from '../components/TripsGrid';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { DestinationsSection } from '../components/DestinationsSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { BlogMasonry } from '../components/BlogMasonry';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-1492">
      <Navbar data-id="element-1493" />
      <main data-id="element-1494">
        <HeroSection data-id="element-1495" />
        <WelcomeSection data-id="element-1496" />
        <TripsGrid data-id="element-1497" />
        <WhyChooseUs data-id="element-1498" />
        <DestinationsSection data-id="element-1499" />
        <ReviewsSection data-id="element-1500" />
        <BlogMasonry data-id="element-1501" />
      </main>
      <Footer data-id="element-1502" />
    </div>;
}